import { render } from "./UserCredentialAssignment.vue?vue&type=template&id=4872f340"
import script from "./UserCredentialAssignment.vue?vue&type=script&lang=js"
export * from "./UserCredentialAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__